import { getField, updateField } from 'vuex-map-fields'

import { SNACKBAR_OPEN } from '../actions'
import { SNACKBAR_OPENING } from '../mutations'
import { mdiCheckboxMarkedCircle, mdiCloseCircle } from '@mdi/js'

const getDefaultState = () => ({
  text: '',
  active: false,
  color: null, // default color for snackbar, can use 'succes', 'yellow' or '#033' or 'rgba(255, 0, 0, 0.5)'
  icon: null,
  timeout: 5000 // ms
})

const icons = [
  {
    color: 'success',
    icon: mdiCheckboxMarkedCircle
  },
  {
    color: 'error',
    icon: mdiCloseCircle
  }
]

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    updateField,
    [SNACKBAR_OPENING] (state, { text, color, timeout }) {
      state.text = text
      state.color = color
      state.timeout = timeout
      state.icon = null // clear from previous state

      for (const entry of icons) {
        if (entry.color === color) {
          state.icon = entry.icon
        }
      }

      state.active = true
    }
  },
  actions: {
    [SNACKBAR_OPEN] (context, { text = '', color = undefined, timeout = 5000 }) {
      context.commit(SNACKBAR_OPENING, { text, color, timeout })
    }
  },
  getters: {
    getField
  }
}
